import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './app'
import './styles/globals.less'
import './styles/font.css'
import './i18n/config'

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(<App />)
